import { lazy } from "react";

export const AdminFormList = lazy(() =>
	import("./AdminFormList/AdminFormsList"),
);

export const ApprovalList = lazy(() => import("./ApprovalList/ApprovalList"));

export const Accommodation = lazy(() =>
	import("./Accommodation/Accommodation"),
);

export const Building = lazy(() => import("./Accommodation/Building/Building"));
export const Rooms = lazy(() => import("./Accommodation/Rooms/Rooms"));
export const Customer = lazy(() => import("./Customer/Customer"));
export const CustomerOrder = lazy(() =>
	import("./CustomerOrder/CustomerOrder"),
);

export const CustomerSurvey = lazy(() =>
	import("./CustomerSurvey/CustomerSurvey"),
);

export const ClientFormList = lazy(() =>
	import("./ClientFormList/ClientFormsList"),
);
export const ClientDetails = lazy(() => import("./Customer/Pages"));
export const ChainOfCustody = lazy(() =>
	import("./Chainofcustody/ChainOfCustody"),
);

export const CustomReports = lazy(() =>
	import("./CustomReports/CustomReports"),
);

export const CMS = lazy(() => import("./CMS"));
export const Dashboard = lazy(() => import("./Dashboard/Dashboard"));
export const LocalDashboard = lazy(() => import("./Dashboard/LocalUser"));
export const DataEntry = lazy(() => import("./DataEntry/DataEntry"));
export const Employee = lazy(() => import("./Employee/Employee"));
export const EmployeeDetails = lazy(() => import("./Employee/Pages"));
export const EmployeeEvaluation = lazy(() => import("./EmployeeEvaluation"));
export const ClientEvaluation = lazy(() => import("./ClientEvaluation"));


export const Subscriber = lazy(() => import("./Subscriber/Subscriber"));
export const SubscriberMethodPackageAdder = lazy(() =>
	import("./Subscriber/SubscriberMethodPackageAdder"),
);
export const SubscriptionPlan = lazy(() =>
	import("./SubscriptionPlan/SubscriptionPlan"),
);
export const Equipment = lazy(() => import("./Equipment/Equipment"));
export const EquipmentRecords = lazy(() =>
	import("./EquipmentRecord/EquipmentsRecord"),
);
export const EquipmentEvaluation = lazy(() => import("./EquipmentEvaluation"));

export const ExpiredItems = lazy(() => import("./ExpiredItems/ExpiredItems"));
export const EmailVerification = lazy(() =>
	import("./EmailVerification/EmailVerification"),
);

export const ExternalUser = lazy(() => import("./ExternalUser/ExternalUser"));
export const ExternalUserSubUser = lazy(() =>
	import("./ExternalUserSubUser/ExternalUserSubUser"),
);
export const EmployeeFormList = lazy(() =>
	import("./EmployeeFormList/EmployeeFormsList"),
);

export const PublicFromList = lazy(() =>
	import("./PublicFormList/PublicFormList"),
);


export const FormsBuilder = lazy(() => import("./FormBuilder/FormsBuilder"));
export const FormsList = lazy(() => import("./FormList/FormsList"));
export const FormsListHistory = lazy(() =>
	import("./FormList/FormListHistory"),
);
export const FormsView = lazy(() => import("./FromViewer/FormView"));

export const ForgetPassword = lazy(() =>
	import("./ForgetPassword/ForgetPassword"),
);
export const InternalUser = lazy(() => import("./InternalUser/InternalUser"));
export const InternalAudit = lazy(() =>
	import("./InternalAudit/InternalAudit"),
);
export const ExternalAudit = lazy(() =>
	import("./ExternalAudit/ExternalAudit"),
);
export const Group = lazy(() => import("./Groups/Group"));
export const GeneralInventory = lazy(() =>
	import("./GeneralInventory/GeneralInventory"),
);
export const Jobs = lazy(() => import("./Jobs/Jobs"));
export const MasterJobs = lazy(() => import("./Jobs/MasterJob"));
export const Login = lazy(() => import("./Login/Login"));
export const Mainlayout = lazy(() => import("./Mainlayout/MainLayout"));
export const ManagmentReview = lazy(() =>
	import("./ManagmentReview/ManagmentReview"),
);
export const Method = lazy(() => import("./Method/Method"));
export const MethodPackages = lazy(() =>
	import("./MethodPackages/MethodPackages"),
);
export const MethodAdder = lazy(() => import("./methodAdder/MethodAdder"));
export const MethodFormView = lazy(() =>
	import("./MethodFormView/MethodFormView"),
);
export const MethodPackageAdder = lazy(() =>
	import("./MethodPackages/MethodpackageAdder"),
);
export const ManageGroup = lazy(() => import("./ManageGroups/ManageGroup"));

export const NonConformityReport = lazy(() =>
	import("./NCR/NonConfirmityReport"),
);
export const NonConformityTicketReview = lazy(() =>
	import("./NCR/pages/NcrReview"),
);
export const NonConformityTicketMainPage = lazy(() =>
	import("./NCR/pages/MainPage"),
);

export const NCRSolution = lazy(() => import("./NCR/pages/NCRSolution"));

export const Print = lazy(() => import("./Print/Print"));

export const RoleAndPermission = lazy(() =>
	import("./RolesAndPermission/RoleAndPermission"),
);

export const Reagentsandchemicals = lazy(() =>
	import("./ReagentsAndChemicals/ReagentsAndChemicals"),
);

export const Report = lazy(() => import("./Report/Report"));
export const ReportVersionHistory = lazy(() => import("./ReportVersionHistory/ReportVersionHistory"));
export const CustomReport = lazy(() => import("./Report/CustomReport"));
export const WorkOrderReport = lazy(() => import("./Report/WorkOrderReport"));


export const SampleName = lazy(() => import("./SampleName/SampleName"));
export const SubSampleName = lazy(() => import("./SubSampleName/SubSampleName"));
export const SampleList = lazy(() => import("./SampleList/SampleList"));
export const SampleCategory = lazy(() =>
	import("./SampleCategories/SampleCategories"),
);

export const Service = lazy(() => import("./Service/Service"));

export const ResetPassword = lazy(() =>
	import("./ResetPassword/ResetPassword"),
);

export const WorkOrder = lazy(() => import("./WorkOrder/WorkOrder"));
export const ManageJob = lazy(() => import("./ManageJobs/Managejob"));

export const OTPPage = lazy(() => import("./OTPPage/OTP"));

export const ReportBuilder = lazy(() => import("./ReportBuilder/ReportBuilder"));
export const ReportTemplates = lazy(() =>
	import("./ReportBuilder/ReportTemplates"),
);

export const ReportHistory = lazy(() =>
	import("./ReportBuilder/ReportVersion"),
);

export const ReportTemplateDetailsReadOnly = lazy(() =>
	import("./ReportBuilder/TemplateDetailsReadOnly"),
);

export const Store = lazy(() => import("./store/Store"));
export const SiteSetting = lazy(() => import("./SiteSetting/index"));
export const SMTPSetting = lazy(() => import("./SMTPSetting/SmtpSetting"));
export const UserSetting = lazy(() => import("./UserSetting/UserSetting"));

export const TemplateDetails = lazy(() =>
	import("./ReportBuilder/TemplateDetails"),
);

export const Training = lazy(() => import("./Training/Training"));
export const PlanTraining = lazy(() => import("./PlanTraining/PlanTraining"));
export const ManageParticipants = lazy(() =>
	import("./PlanTraining/ManageParticipants/ManageParticipants"),
);

export const PageNotFound = lazy(() => import("./404/404"));
export const IdentificationRulesPage = lazy(() =>
	import("./IdentificationAndRules/IdentifictionAndRules"),
);
export const ManageRule = lazy(() =>
	import("./IdentificationAndRules/ManageRule"),
);

export const Vendor = lazy(() => import("./Vendor/Vendor"));
export const VendorDetails = lazy(() => import("./Vendor/Pages"));
export const VendorFormList = lazy(() =>
	import("./VendorFormList/VendorFormsList"),
);

export const VendorCategory = lazy(() =>
	import("./VendorCategories/VendorCategories"),
);

export const VendorSubCategory = lazy(() =>
	import("./VendorSubCategories/VendorSubCategories"),
);

export const VendorEvaluation = lazy(() => import("./VendorEvaluation"));

export const WorksheetBuilder = lazy(() =>
	import("./WorkSheet/WorksheetBuilder"),
);
export const WorksheetList = lazy(() => import("./WorkSheet/WorkSheetList"));
export const WorksheetVersion = lazy(() =>
	import("./WorkSheet/WorkSheetVersion"),
);

export const Document = lazy(() => import("./Document/Document"));
export const DocumentRecords = lazy(() =>
	import("./DocumentRecord/DocumentsRecord"),
);

export const ClientDocument = lazy(() =>
	import("./ClientDocument/ClientDocument"),
);
export const ClientDocumentList = lazy(() =>
	import("./ClientDocument/DocumentList"),
);

export const QualityManagment = lazy(() =>
	import("./QualityManagment/QualityManagment"),
);
export const SubQualityManagment = lazy(() =>
	import("./QualityManagment/pages/SubQualityManagment"),
);
export const ListOfDocument = lazy(() =>
	import("./QualityManagment/pages/ListOfDocument"),
);
export const QASetting = lazy(() =>
	import("./QualityManagment/pages/QASettings"),
);

export const UserActivity = lazy(() => import("./UserActivity/UserActivity"));
export const UserVersion = lazy(() => import("./UserActivity/UserVersion"));

export const MasterNameList = lazy(() =>
	import("./MasterNameList/MasterNameList"),
);

export const AdminUser = lazy(() => import("./AdminUser/AdminUser"));

export const IntraLaboratoryProgram = lazy(() =>
	import("./IntraLaboratoryProgram/IntraLaboratoryProgram"),
);

export const InterLaboratoryProgram = lazy(() =>
	import("./InterLaboratoryProgram/InterLaboratoryProgram"),
);

export const PTProgram = lazy(() => import("./Ptprogram/PtProgram"));

export const Complains = lazy(() => import("./Complains/Complains"));
export const ComplainsReview = lazy(() => import("./Complains/pages/MainPage"));
export const SuggestionReview = lazy(() => import("./suggestion/pages/MainPage"));
export const Suggestion = lazy(() => import("./suggestion/Suggestion"));
export const SampleCategories = lazy(() =>
	import("./SampleCategories/SampleCategories"),
);
export const SurveyForm = lazy(() =>
	import("./CustomerSurvey/form/SurveyForm"),
);

export const SurveyAnalysis = lazy(() =>
	import("./SurveyAnalysis/SurveyAnalysis"),
);

export const Analysis = lazy(() =>
	import("./Analysis/Analysis"),
);

export const RecurringSurveyAnalysis = lazy(() =>
	import("./RecurringSurveyAnalysis/Analysis"),
);

export const ProjectList = lazy(()=>
	import("./Projects/index"),
);

export const DraftReportApproval = lazy(()=>
	import("./DraftReportApproval/index")
)

export const ProjectDetails = lazy(()=>import("./ProjectDetails/index"));

export const ProjectWorkOrderDetails = lazy(()=>import("./ProjectWorkOrderDetails/index"));

export const ProjectWorkOrderDocketList = lazy(()=>import("./ProjectWorkOrderDocketList/index"));

export const ProjectWorkOrderDocketSampleDetails = lazy(()=>import("./ProjectWorkOrderDocketSampleDetails/index"));

export const ProjectWorkOrderDocketSampleTestDetails = lazy(()=>import("./ProjectWorkOrderDocketSampleTestDetails/index"));

export const ProjectWorkOrderDocketSampleSubSampleDetails = lazy(()=>import("./ProjectWorkOrderDocketSampleSubSampleDetails/index"));

export const ProjectWorkOrderDocketSampleSubSampleJobDetails = lazy(()=>import("./ProjectWorkOrderDocketSampleSubSampleJobDetails/index"))

export const NewSampleNames = lazy(()=>import("./NewSampleNames/index"))

export const NewSampleManageTests = lazy(()=>import("./NewSampleManageTests/index"))

export const SuppliersManageCars = lazy(()=>import("./SuppliersManageCars/SuppliersManageCars"));

export const SuppliersManageStations = lazy(()=>import("./SuppliersManageStations/SuppliersManageStations"));

export const SupplierCars = lazy(()=>import("./SupplierCars/SupplierCars"));

export const CertifiedReferenceMaterial = lazy(()=>import("./CertifiedReferenceMaterial/CertifiedReferenceMaterial"));

export const CalibrationDevices = lazy(()=>import("./CalibrationDevices/CalibrationDevices"));

export const CalibrationDevicesRecords = lazy(()=>import("./CalibrationDevicesRecords/CalibrationDevicesRecords"))

export const OrganizationProfileFormList = lazy(()=>import("./OrganizationProfileFormList/OrganizationProfileFormList"))

export const EquipmentFormList = lazy(()=>import("./EquipmentFormList/EquipmentFormList"))

export const LeadCustomerList = lazy(() =>import("./Lead_customer/index"))

export const RequestList = lazy(() =>import("./Requests/index"))

export const LogList = lazy(() => import("./Log/index"));

export const QuotationList = lazy(() => import("./Quotation/index"));

export const ClientRequestList = lazy(() => import("./ClientRequests/index"));

export const PoList = lazy(() => import("./Po/index"));

export const QuotationApproval = lazy(() => import("./QuotationApproval/index"));

export const LabVisitor = lazy(() => import("./LabVisitors/index"));
